import styled from 'styled-components';
import { Box } from '@origin-digital/layout';
export var ContainerBaseSkin = styled(Box).withConfig({
  displayName: "ContainerBaseskin__ContainerBaseSkin",
  componentId: "sc-1ww4k7-0"
})(["display:inline-block;position:relative;will-change:opacity,transform,color;"]);